/**
 * @param text Text to truncate
 * @param maxCharacters Maximum allowed characters
 * @param useWordBoundary Preserve entire word or not
 */
export const truncateText = (
  text: string,
  maxCharacters: number,
  useWordBoundary: boolean,
): string => {
  if (!text) {
    return '';
  }
  if (text.length <= maxCharacters) {
    return text;
  }
  const subString = text.substr(0, maxCharacters - 1);

  return `${ useWordBoundary
    ? subString.substr(0, subString.lastIndexOf(' '))
    : subString
  }...`;
};

// usage
truncateText('not very long', 11, true); // => not very...
